export default __webpack_public_path__ + "static/media/picpay_semfundo.7b11a520.png";